import { useRoutes } from 'react-router-dom';
import { adminRoutes } from './admin-routes';
import { authRoutes } from './auth-routes';
import { ownerRoutes } from './owner-routes';
import { publicRoutes } from './public-routes';
import { trainerRoutes } from './trainer-routes';

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([authRoutes, adminRoutes, trainerRoutes, ...ownerRoutes, ...publicRoutes]);
}
